import type { ReactNode } from "react";
import "../../../src/ui/tokens.css";
import "../../../src/ui/collapsible.css";

/**
 * A panel behind a quiet text trigger, on native <details>: no script at all. The trigger says
 * `label` while closed ("Show 2 more") and `openLabel` while open ("Show less"); the browser
 * gives it its expanded state. With `triggerAfter`, the trigger follows the panel it opened,
 * as "Show more" under a list does.
 *
 * Parts: `.ui-collapsible` (Root, `[open]` while open), `.ui-collapsible-trigger` (Trigger),
 * `.ui-collapsible-panel` (Panel).
 */
export function Collapsible({
  label,
  openLabel = label,
  triggerAfter = false,
  open = false,
  className,
  children,
}: {
  label: string;
  openLabel?: string;
  triggerAfter?: boolean;
  open?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <details
      className={["ui-collapsible", className].filter(Boolean).join(" ")}
      data-ui="collapsible"
      data-trigger={triggerAfter ? "end" : undefined}
      open={open}
    >
      <summary className="ui-collapsible-trigger">
        <span className="ui-collapsible-closed-label">{label}</span>
        <span className="ui-collapsible-open-label">{openLabel}</span>
      </summary>
      <div className="ui-collapsible-panel">{children}</div>
    </details>
  );
}
